

export class ITMethodDto implements IITMethodDto {
    id!: number | undefined;
    regime!: string | undefined;
    isActive!: boolean;

    constructor(data?: IITMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regime = _data["regime"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ITMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new ITMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regime"] = this.regime;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IITMethodDto {
    id: number | undefined;
    regime: string | undefined;
    isActive: boolean;
}

